/**
 * assets/recipes.js
 * Client-side search + tag filtering over the recipe cards already
 * rendered by sections/recipe-list.liquid (progressive enhancement — the
 * grid works fine unfiltered with JS off). Coming Soon cards are excluded
 * from search/filter matches by default via a data flag, so they never
 * masquerade as a real result.
 */
(function () {
  const root = document.querySelector("[data-recipe-list]");
  if (!root) return;

  const searchInput = root.querySelector("[data-recipe-search]");
  const filterPills = Array.from(root.querySelectorAll("[data-recipe-filters] .pill"));
  const cards = Array.from(root.querySelectorAll("[data-recipe-card]"));
  const countEl = root.querySelector("[data-recipe-count]");
  const noResultsEl = root.querySelector("[data-recipe-no-results]");

  let activeFilter = "all";

  function applyFilters() {
    const term = (searchInput.value || "").trim().toLowerCase();
    let visibleCount = 0;

    cards.forEach((card) => {
      const title = (card.dataset.title || "").toLowerCase();
      const tags = (card.dataset.tags || "").split(",");

      const matchesFilter = activeFilter === "all" || tags.includes(activeFilter);
      const matchesSearch = term === "" || title.includes(term);
      const isComingSoon = card.classList.contains("is-coming-soon");
      const filtering = activeFilter !== "all" || term !== "";
      const visible = matchesFilter && matchesSearch && !(filtering && isComingSoon);

      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    countEl.textContent = `${visibleCount} recipe${visibleCount === 1 ? "" : "s"}`;
    noResultsEl.hidden = visibleCount !== 0;

    document.dispatchEvent(
      new CustomEvent("dyet:recipe_search", { detail: { term, filter: activeFilter, results: visibleCount } })
    );
  }

  searchInput.addEventListener("input", applyFilters);

  filterPills.forEach((pill) => {
    pill.addEventListener("click", () => {
      filterPills.forEach((p) => p.classList.remove("active"));
      pill.classList.add("active");
      activeFilter = pill.dataset.filter;
      applyFilters();
    });
  });

  applyFilters();
})();
